<template lang="">
  <v-container id="body-container-card-fvl">
    <BreadCrumbs :items="itemsBreadCrumbs" />
    <LoaderLinear />
    <div id="fvl-container-card-table">
    <v-card elevation="0" class="fvl-card-searcher-table">
      <div class="d-flex justify-center">
        <v-text-field
          v-model="search"
          class="mb-6 searcher-input-fvl elevation-1"
          label="Buscador de productos"
          append-icon="search"
          dense
          filled
          hide-details
        ></v-text-field>
      </div>
      <v-data-table
        :headers="dataTableheaders"
        :items="this.products.products"
        :search="search"
      >
        <template v-slot:item.actions="{ item }">
          <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
            v-if="
              user.permissions.indexOf(permissionsAll.product_update) >= 0 ||
                user.person.types_person.id === 3
            "
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="deleteItem(item, 1)"
            v-if="
              user.permissions.indexOf(permissionsAll.product_delete) >= 0 ||
                user.person.types_person.id === 3
            "
          >
            delete
          </v-icon>
        </template>
      </v-data-table>
    
    </v-card>
    </div>
    <SnackBar />
    <ButtonAdd
      :link="linkAdd"
      v-if="
        user.permissions.indexOf(permissionsAll.product_create) >= 0 ||
          user.person.types_person.id === 3
      "
    />
    <DialogConfirm @action="deleteProduct" />
    <Overlay />
  </v-container>
</template>
<script>
import router from "../../router";
import {
  links,
  itemsBreadCrumbs,
  beginRequest,
  endRequest,
} from "../../helpers";
import { mapState } from "vuex";
import permissions from "../../helpers/permissions";
import {
  LoaderLinear,
  SnackBar,
  Overlay,
  DialogConfirm,
  BreadCrumbs,
  ButtonAdd,
} from "../../components/_commons";
export default {
  name: "CardRoles",
  components: {
    BreadCrumbs,
    ButtonAdd,
    LoaderLinear,
    DialogConfirm,
    SnackBar,
    Overlay,
  },
  data() {
    return {
      linkAdd: links.product.create,
      itemsBreadCrumbs: itemsBreadCrumbs.productList,
      search: "",
      dataTableheaders: [
        {
          text: "Descripción",
          align: "start",
          value: "description",
          width: 400,
          class:"file-name-table"
        },
        {
          text: "Enlace",
          align: "start",
          value: "link",
          class:"file-name-table"
        },
        {
          text: "Marca",
          align: "start",
          value: "get_sub_brand.description",
          class:"file-name-table"
        },
        { text: "Acciones", value: "actions", class:"file-name-table", sortable: false },
      ],
      url: "",
      actionDialog: "",
      permissionsAll: permissions,
    };
  },
  methods: {
    async editItem(item) {
      await this.$store.dispatch("removeProductSelectedAction");
      router.push(`${links.product.update}/${item.id}`);
    },
    async deleteItem(item) {
      const msg = `¿Esta seguro que desea eliminar el producto "${item.description}"?`;

      await this.$store.dispatch("setIdItemDialogAction", item.id);
      await this.$store.dispatch("setMsgDialogConfirmAction", msg);
      await this.$store.dispatch("setDialogShowAction");
    },
    async deleteProduct() {
      await beginRequest();
      await this.$store.dispatch("setDialogShowAction");
      const { status, snack } = await this.$store.dispatch(
        "deleteProductAction",
        this.ui.idItemDialog
      );
      await endRequest(snack, status);
    },
  },
  computed: {
    ...mapState({
      products: (state) => state.products,
      ui: (state) => state.ui,
      user: (state) => state.user,
    }),
  },
  async created() {
    await beginRequest();
    const { status, snack } = await this.$store.dispatch("setProductsAction");
    await endRequest(snack, status);
  },
};
</script>
